module.exports = __webpack_public_path__ + "img/musical_notes.2293f2d0.gif";